import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'

const {TextArea} = Input

class SearchMultiField extends Component {
    _timeOut = null

    _handleChange = e => {
        const {value} = e.target

        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            const {field, onChangeInput} = this.props
            onChangeInput(field, value)
        }, 500)
    }

    render() {
        const {placeholder, title} = this.props

        return (
            <div className='SearchField Multi'>
                <div className='mb-1 font-weight-bold'>{title}</div>
                <TextArea
                    placeholder={placeholder}
                    allowClear={true}
                    autoSize={{minRows: 1, maxRows: 1}}
                    onChange={this._handleChange}
                />
            </div>
        )
    }
}

SearchMultiField.defautlProps = {
    placeholder: ''
}

SearchMultiField.propTypes = {
    field: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    title: PropTypes.string
}

export default SearchMultiField
